import { isBareChord } from './chord.js';

const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);
const EDITABLE_ROLES = new Set(['textbox', 'combobox', 'searchbox', 'spinbutton']);

/** El target de un evento de teclado puede no ser un Element (document, window). */
type MaybeElement = {
  tagName?: string;
  isContentEditable?: boolean;
  getAttribute?: (name: string) => string | null;
} | null;

export const isEditableTarget = (target: MaybeElement): boolean => {
  if (target === null) return false;
  if (target.tagName !== undefined && EDITABLE_TAGS.has(target.tagName)) return true;
  if (target.isContentEditable === true) return true;
  const role = target.getAttribute?.('role') ?? null;
  return role !== null && EDITABLE_ROLES.has(role);
};

/**
 * Escribir "assign" en un campo de búsqueda no debe asignar, cambiar estado y abrir la
 * paleta por el camino. Se filtran solo los acordes sin modificadores: `⌘K` sigue
 * funcionando dentro de un input y `Escape` también, porque cerrar es universal.
 */
export const shouldIgnoreChord = (
  chord: string,
  target: MaybeElement,
  isComposing = false,
): boolean => {
  if (isComposing) return true;
  if (chord === 'escape') return false;
  return isBareChord(chord) && isEditableTarget(target);
};
